import React from 'react';
import {withStore} from "../../hocs";
import {observer} from "mobx-react";
import {EnumUserType} from "../../enum/EnumUserType";
import {BreadCrumbs} from "../../components/tpl/BreadCrumbs";
import {RedirectUrl} from "../../components/RedirectUrl";
import {EmailReplay} from "../../components/user/EmailReplay";
import {adminPanelUrl} from "../../constants/adminPanelPath";


// @ts-ignore
@withStore
@observer
export class AdminEmailReplayPage extends React.Component {

    componentDidMount() {
        // @ts-ignore
        const {store} = this.props;
        store?.pageAdminEmailReplayStore.init();
        store.basePageStore.setBreadCrumbs([{name: 'Администрирование', url: adminPanelUrl()},{name: 'Авторизация под пользователями', url: adminPanelUrl('email-replay')}]).setTitleInBreadCrumbs();
        store?.componentTopSearchStore.clearSearch();
    }

    render() {
        // @ts-ignore
        const {store} = this.props;
        const {
            arUsers,
            onReplayEmail
        } = store?.pageAdminEmailReplayStore;
        const {
            onFilterUser,
            search,
            setShowNextStep,
            showNextStep,
            activeId,
            userEmail,
            changeUserEmail,
            deleteUser,
            updateUser,
            sendEmailReplay
        } = store?.pageAdminEmailReplayStore;
        let type = store.mainStore.getUserType();
        let arItemsV = [];
        if (search.length > 2) {
            arItemsV = arUsers.filter((item: any) => item.search.includes(search?.toUpperCase()));
        } else {
            arItemsV = arUsers;
        }
        return (
            <>
                <RedirectUrl/>
                <div className="container">
                    <div className="breadcrumbs">
                        <div className="breadcrumbs-wrapper">
                            <BreadCrumbs/>
                        </div>
                    </div>
                    <div className="catalog-title">
                        <h1 className="catalog-title__text"> Повторная отправка пользователям подтверждения электронной почты</h1>
                    </div>
                    {[EnumUserType.adminAuth, EnumUserType.root].includes(type) ?
                        <EmailReplay
                            onFilterUser={onFilterUser}
                            onHandlerClick={onReplayEmail}
                            setShowNextStep={setShowNextStep}
                            showNextStep={showNextStep}
                            activeId={activeId}
                            userEmail={userEmail}
                            arUsers={arItemsV}
                            changeUserEmail={changeUserEmail}
                            deleteUser={deleteUser}
                            updateUser={updateUser}
                            sendEmailReplay={sendEmailReplay}
                        />
                        : null}
                </div>
            </>
        )
    }
}